module.exports = __webpack_public_path__ + "static/media/fullPageCatalogImages.2eab2761.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/fullPageCatalogImages.png
// module id = 998
// module chunks = 0